import { gql } from "@apollo/client";

export const PROMOTE_PROPOSED_RUN = gql`
  mutation PromoteProposedRunNext($stackId: ID!, $runId: ID!) {
    runPromote(stack: $stackId, run: $runId) {
      id
    }
  }
`;
